import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app";

platformBrowserDynamic().bootstrapModule(AppModule);


// WEBPACK FOOTER //
// ./src/main.ts